export default __webpack_public_path__ + "static/Connect-27f1b4c5da5e3e8945ffb0764f63ddee.png";